"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarDay;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _localeLanguageDays = require("./localeLanguageDays");
var _locales = require("../../utils/locales");
function CalendarDay(props) {
  const buttonClasses = (0, _classnames.default)({
    "CalendarDay": true,
    "t-body-med": true,
    "CalendarDay--hovered": props.isHovered,
    "CalendarDay--rangeStart": props.placeInRange === "beginning",
    "CalendarDay--rangeMiddle": props.placeInRange === "middle",
    "CalendarDay--rangeEnd": props.placeInRange === "end",
    "CalendarDay--isLoading": props.isLoading
  });
  const spanClasses = (0, _classnames.default)({
    "CalendarDay-content": true,
    "CalendarDay-content--chosen": props.isChosen,
    "CalendarDay-content--hovered": props.isHovered && !props.isDisabled,
    "CalendarDay-content--rangeStart": props.placeInRange === "beginning",
    "CalendarDay-content--rangeMiddle": props.placeInRange === "middle",
    "CalendarDay-content--rangeEnd": props.placeInRange === "end",
    "is-today": props.isToday && !props.isDisabled,
    "t-label-large": props.isChosen
  });
  function preventHoverActionsIfMobile(callback, data) {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UserAgent also contains "Android"
    if (/windows phone/i.test(userAgent) || /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return;
    }
    callback(data);
  }
  return /*#__PURE__*/_react.default.createElement("button", {
    className: buttonClasses,
    disabled: props.isDisabled ? "disabled" : false,
    onClick: event => props.onClick(props.date),
    onMouseOver: event => preventHoverActionsIfMobile(props.onMouseOver, props.date),
    onMouseOut: event => preventHoverActionsIfMobile(props.onMouseOut, props.date),
    type: "button",
    value: props.date.format("YYYY-MM-DD"),
    "aria-label": "".concat(_localeLanguageDays.mobileDatePickerOptions[props.language].select, " ").concat(props.date.format("dddd, MMMM Do YYYY"))
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: spanClasses
  }, props.date.format("D")));
}
CalendarDay.propTypes = {
  /** Date type for showing user the date and providing info on click */
  date: _propTypes.default.object.isRequired,
  /** Show user if day is in their chosen list */
  isChosen: _propTypes.default.bool,
  /** Show user they can't interact with this day */
  isDisabled: _propTypes.default.bool,
  /** Show user our custom hover effect */
  isHovered: _propTypes.default.bool,
  /** Show user that this date is today */
  isToday: _propTypes.default.bool,
  /** For styling the range effect */
  placeInRange: _propTypes.default.string,
  /** Handles clicks, passes date to callback */
  onClick: _propTypes.default.func.isRequired,
  /** Handle mouse overs, passes date to callback */
  onMouseOver: _propTypes.default.func.isRequired,
  /** Handle mouse outs, passes date to callback */
  onMouseOut: _propTypes.default.func.isRequired,
  /** Selected user Language */
  language: _propTypes.default.oneOf([_locales.locales.en, _locales.locales.es, _locales.locales.fr, _locales.locales.pt, _locales.locales.zh, _locales.locales.tl, _locales.locales.de, _locales.locales.it, _locales.locales.ko, _locales.locales.ja, _locales.locales.hi]).isRequired
};